import styled from "styled-components";
import { motion } from "framer-motion";

export const Trigger = styled(motion.button)`
    width: 100%;
    max-width: 100%;
    border: 2px solid #d9d9d9;
    border-radius: 10px;
    background: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer;
    box-sizing: border-box;
    padding: 4px 8px;
    position: relative;
    transition: .3s;

    :is([data-disabled = true]) {
        background: var(--disabled-color);
        border-color: var(--disabled-color);
        cursor: not-allowed;

        :hover {
            border-color: var(--disabled-color);

            svg.Trigger__arrow {
                color: var(--disabled-text-color);
            }
        }
    }

    :hover:not([data-disabled = true]) {
        border: 2px solid #5da47d;

        svg.Trigger__arrow {
            color: var(--primary-color);
        }
    }

    div.Trigger__content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        min-width: 0;

        span.Trigger__content__label {
            font-size: 11px;
            font-weight: 500;
            color: var(--text-color);
            white-space: nowrap;
            line-height: 14px;
            margin: 0;
            padding: 0;

            small.Trigger__content__label__rule {
                font-size: 9px;
                color: var(--text-color-light);
            }
        }

        div.Trigger__content__selected {
            width: 100%;
            min-width: 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 4px;
            color: var(--text-color);
            white-space: nowrap;
            overflow: hidden;
            font-weight: 700;
            font-size: 12px;
            line-height: 16px;

            svg.Trigger__content__selected__icon {
                flex-shrink: 0;
                color: var(--text-color-light);
                font-size: 11px;
            }

            span.Trigger__content__selected__value {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span.Trigger__content__selected__empty {
                font-style: italic;
                font-weight: 500;
                font-size: 11px;
                color: var(--text-color-light);
                opacity: 0.8;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    svg.Trigger__arrow {
        flex-shrink: 0;
        color: var(--text-color-light);
        font-size: 11px;
    }
`;

export const ListaCompacta = styled(motion.div)`
    max-height: 50vh;
    background: #fff;
    border-radius: 10px;
    box-shadow: rgba(153, 153, 153, 0.5) 0px 0px 10px;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    div.ListaCompacta__busca {
        width: 100%;
        height: 40px;
        min-height: 40px;
        border: 2px solid var(--border-color);
        border-radius: 10px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0px 5px 0px 10px;
        gap: 8px;

        :focus-within {
            border-color: var(--primary-color);
        }

        svg.ListaCompacta__busca__icon {
            color: var(--text-color-light);
        }

        input {
            width: 100%;
            height: 100%;
            border: none;
            background: transparent;

            ::placeholder {
                opacity: 0.5;
                font-weight: 400;
            }
        }

        button.ListaCompacta__busca__limpar {
            width: 20px;
            height: 20px;
            border: none;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin-right: 5px;
            cursor: pointer;

            :active {
                transform: scale(0.98);
            }

            :hover {
                background: rgba(255, 0, 0, 0.3);
            }
        }
    }

    div.ListaCompacta__list {
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 5px;

        button.ListaCompacta__list__item {
            margin: 0;
            width: 100%;
            min-height: 40px;
            display: flex;
            align-items: center;
            gap: 7px;
            box-sizing: border-box;
            padding: 0px 10px;
            border: none;
            background: white;
            cursor: pointer;
            border-radius: 7px;
            transition: .2s;
            font-size: 14px;
            text-align: left;
            color: var(--text-color);

            :active {
                transform: scale(0.98);
            }

            :hover {
                background: #d5ffe8;
            }

            :is([data-active = true]) {
                background: var(--primary-color);
                color: #fff;

                :hover {
                    background: rgb(255, 89, 92, 0.9);
                    text-decoration: line-through;
                    text-shadow: 0px 0px 2px rgba(83, 0, 1, 0.9);
                }

                div.ListaCompacta__list__item__circle {
                    border-color: white;
                    background: white;
                }
            }

            div.ListaCompacta__list__item__circle {
                width: 13px;
                min-width: 13px;
                max-width: 13px;
                height: 13px;
                min-height: 13px;
                max-height: 13px;
                border: 3px solid var(--text-color-light);
                border-radius: 50%;
            }

            span.ListaCompacta__list__item__descr {
                flex: 1;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span.ListaCompacta__list__item__extra {
                flex-shrink: 0;
                font-size: 10px;
                font-weight: 600;
                text-transform: none;
                color: var(--primary-color);
                background: #d5ffe8;
                border-radius: 5px;
                box-sizing: border-box;
                padding: 2px 6px;
                white-space: nowrap;
            }
        }
    }
`;
